/**
 * Amenities and Facilities Section Component
 * Displays amenities and facilities available at the location
 */

import React from 'react';
import { spacing } from '@/design-system/utils';
import { SectionHeader } from '@/components/ui/section-header';
import { IconItemList, IconItem } from './IconItemList';

export interface AmenityItem {
  id: string;
  label: string;
  icon: string;
}

export interface AmenitiesAndFacilitiesSectionProps {
  title?: string;
  items: AmenityItem[];
}

export const AmenitiesAndFacilitiesSection: React.FC<
  AmenitiesAndFacilitiesSectionProps
> = ({ title = 'Amenities & Facilities', items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  // Map AmenityItem to IconItem
  const iconItems: IconItem[] = items.map(item => ({
    label: item.label,
    icon: item.icon,
    id: item.id,
    key: item.id,
  }));

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <SectionHeader title={title} />
      <div
        style={{
          marginTop: spacing[3],
          padding: `${spacing[3]}px ${spacing[3]}px`,
        }}
      >
        <IconItemList
          items={iconItems}
          iconSize={20}
          iconType='amenity'
          mobileColumns={2}
          desktopColumns={3}
          rowGap={spacing[4]}
          columnGap={spacing[6]}
        />
      </div>
    </div>
  );
};
